import { render, staticRenderFns } from "./OccurrencesTable.vue?vue&type=template&id=e6b64052&"
import script from "./OccurrencesTable.vue?vue&type=script&lang=js&"
export * from "./OccurrencesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports